import {
	SERVER_SEND_MAIL_RESPONSE,
	SERVER_GET_MAIL_RESPONSE_DATA,
	RESET_MAIL_RESPONSE_MODALS,
	ADD_MAIL_RESPONSE_MESSAGE
} from 'constants/ActionTypes';
import Moment from 'moment';

export const sendMailResponse = (message, reportId, responsekey) => {
	return { type: SERVER_SEND_MAIL_RESPONSE, payload: { message, reportId, responsekey } };
};

export const getMailResponseData = (reportId, responsekey) => {
	return { type: SERVER_GET_MAIL_RESPONSE_DATA, payload: { reportId, responsekey } };
};

export const resetResponseModals = () => {
	return { type: RESET_MAIL_RESPONSE_MODALS };
};

export const addChatMessage = message => {
	return { type: ADD_MAIL_RESPONSE_MESSAGE, payload: { message: { message, date: Moment(), id: new Date().getTime(), type: 1 } } };
};



// WEBPACK FOOTER //
// ./actions/MailResponse.js